<template>
  <div style="padding: 25px; max-width: 600px; margin: auto">
    <el-card :body-style="{padding: '50px'}">
      <h1>关注信息填报</h1>
      <el-form
          ref="concerned-info-form"
          :model="concerned"
          size="small"
          status-icon
      >
        <el-form-item
            label="标题"
            prop="title"
            :rules="[
        {required: true, message: '标题不能为空', trigger: 'blur'},
        {min: 2, max: 255, message: '标题长度不能少于2个字符，也不能超过200个字符', trigger: 'blur'}]"
        >
          <el-input
              v-model="concerned.title"
              placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="接收推送" prop="receiveDailyReport">
          <el-switch v-model="concerned.receiveDailyReport"></el-switch>
        </el-form-item>
        <el-form-item label="起始时间" prop="receiveStart" :rules="{required: true, message: '起始时间必填'}">
          <el-time-select
              style="width: 200px"
              v-model="concerned.receiveStart"
              :picker-options="{format: 'HH:mm', step: '00:30', start: '00:00', end: '23:30'}"
          >
          </el-time-select>
        </el-form-item>
        <el-form-item label="截止时间" prop="receiveEnd" :rules="{required: true, message: '截止时间必填'}">
          <el-time-select
              style="width: 200px"
              v-model="concerned.receiveEnd"
              :picker-options="{format: 'HH:mm', step: '00:30', start: '00:00', end: '23:30'}"
          >
          </el-time-select>
        </el-form-item>
        <el-form-item
            label="包含关键字"
            prop="includeWords"
            :rules="[
        {required: true, message: '包含关键字不能为空', tigger: 'blur'},
        {max: 250, message: '包含关键字总长度不能超过250个字符', tigger: 'blur'}
        ]"
        >
          <div>
            <input-block
                v-model="concerned.includeWords"
                text="添加包含关键字"
            ></input-block>
          </div>
        </el-form-item>
        <el-form-item
            label="排除关键字"
            prop="excludeWords"
            :rules="[
        {max: 250, message: '排除关键字总长度不能超过250个字符', tigger: 'blur'}
        ]"
        >
          <input-block
              v-model="concerned.excludeWords"
              text="添加排除关键字"
          ></input-block>
        </el-form-item>
        <el-form-item
            label="包含地区"
            prop="includeAreas"
            :rules="[
        {max: 250, message: '包含地区总长度不能超过250个字符', tigger: 'blur'}
        ]"
        >
          <input-block
              v-model="concerned.includeAreas"
              text="添加包含地区"
          ></input-block>
        </el-form-item>
        <el-form-item
            label="排除地区"
            prop="excludeAreas"
            :rules="[
        {max: 250, message: '排除地区总长度不能超过250个字符', tigger: 'blur'}
        ]"
        >
          <input-block
              v-model="concerned.excludeAreas"
              text="添加排除地区"
          ></input-block>
        </el-form-item>
        <el-form-item
            label="公司名包含"
            prop="includeCompany"
            :rules="[
        {max: 250, message: '包含公司名总长度不能超过250个字符', tigger: 'blur'}
        ]"
        >
          <input-block
              v-model="concerned.includeCompany"
              text="添加公司名关键字"
          ></input-block>
        </el-form-item>
        <el-form-item
            label="公司名排除"
            prop="excludeCompany"
            :rules="[
        {max: 250, message: '排除公司名总长度不能超过250个字符', tigger: 'blur'}
        ]"
        >
          <input-block
              v-model="concerned.excludeCompany"
              text="添加公司名排除关键字"
          ></input-block>
        </el-form-item>
        <div class="text-center">
          <el-button
              icon="el-icon-back"
              size="mini"
              @click="backward"
          ><span class="sm-hidden">返回</span>
          </el-button>
          <el-button
              type="primary"
              icon="el-icon-upload"
              size="mini"
              @click="submit"
          ><span class="sm-hidden">提交</span>
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>

import ConcernedInfo from '@/models/ConcernedInfo'
import InputBlock from '@/components/inputs/InputBlock'
import ConcernedInfoService from '@/services/concernedInfo/ConcernedInfoService'

export default {
  components: {InputBlock},
  props: {
    model: ConcernedInfo
  },
  data() {
    return {
      concerned: new ConcernedInfo()
    }
  },
  watch: {
    model(n) {
      this.concerned = new ConcernedInfo(n)
    }
  },
  methods: {
    submit() {
      this.$refs['concerned-info-form'].validate(valid => {
        if (valid) {
          ConcernedInfoService.save(this.concerned).then(resp => {
            this.$message.success('添加' + this.concerned.title + ' 关注信息成功')
            this.$emit('saved', resp)
          })
        }
      })
    },
    backward() {
      this.$emit('back')
    }
  }
}
</script>
<style scoped>
</style>
